function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3008",
  "data-name": "Group 3008",
  transform: "translate(-0.158)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(0.158)",
  fill: "rgba(161,164,172,0.2)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_549",
  "data-name": "Group 549",
  transform: "translate(9.952 7.626)"
}, /*#__PURE__*/React.createElement("g", {
  id: "insert_drive_file_black_24dp",
  "data-name": "insert drive file black 24dp"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M1421.587-255.841v1.9a2.758,2.758,0,0,1-.814,1.956l-5.419,5.39a2.76,2.76,0,0,1-1.946.8H1410.9a1.523,1.523,0,0,1-1.518-1.525l.008-12.2a1.528,1.528,0,0,1,1.518-1.525h5.468a1.5,1.5,0,0,1,1.075.45l3.684,3.684A1.5,1.5,0,0,1,1421.587-255.841Z",
  transform: "translate(-1409.385 261.05)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M1420.784-243.882a.58.58,0,0,1,0,.824l-1.228,1.228a.484.484,0,0,0-.061.069,1.716,1.716,0,0,0-.412,1.525h-1.136a3,3,0,0,1,.2-1.525,2.946,2.946,0,0,1,.595-.892l1.228-1.228A.585.585,0,0,1,1420.784-243.882Z",
  transform: "translate(-1411.411 257.014)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M1425.618-239.6a.608.608,0,0,1,.16.374h-1.373l.4-.4A.585.585,0,0,1,1425.618-239.6Z",
  transform: "translate(-1412.95 256)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M1425.4-244.41a.578.578,0,0,1,.031.816l-2.456,2.456a.594.594,0,0,1-.824,0,.57.57,0,0,1-.046-.747.436.436,0,0,1,.053-.069l2.418-2.425.031-.031A.571.571,0,0,1,1425.4-244.41Z",
  transform: "translate(-1412.377 257.138)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M1427.753-248.145v4.629l-.976.976-.023.023a.571.571,0,0,1-.816-.023.578.578,0,0,1,.023-.816l1.159-1.159a1.8,1.8,0,0,0,.188-2.392,1.735,1.735,0,0,0-2.575-.132l-1.251,1.251a.571.571,0,0,1-.816-.023.578.578,0,0,1,.023-.816l1.228-1.228.076-.076a3.009,3.009,0,0,1,.709-.5A2.894,2.894,0,0,1,1427.753-248.145Z",
  transform: "translate(-1412.5 258.128)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_544",
  "data-name": "Group 544"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M1420.038-243.882l-1.228,1.228a2.948,2.948,0,0,0-.595.892h1.35a.5.5,0,0,1,.061-.069l1.228-1.228a.58.58,0,0,0,0-.824A.585.585,0,0,0,1420.038-243.882Z",
  transform: "translate(-1411.481 257.014)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M1421.137-256.916l-3.684-3.684a1.5,1.5,0,0,0-1.075-.45h-5.468a1.528,1.528,0,0,0-1.518,1.525l-.008,12.2a1.523,1.523,0,0,0,1.518,1.525h3.061a1.417,1.417,0,0,0,1-.412l6.208-6.174a1.417,1.417,0,0,0,.417-1v-2.454A1.5,1.5,0,0,0,1421.137-256.916Zm-4.126,1.2a.762.762,0,0,1-.763-.763v-3.432l4.195,4.195Z",
  transform: "translate(-1409.385 261.05)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M1422.145-241.826h.946a1.526,1.526,0,0,0,1.525-1.525v-.969l-2.418,2.425A.436.436,0,0,0,1422.145-241.826Z",
  transform: "translate(-1412.414 257.079)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M1423.917-247.76l-1.228,1.228a.578.578,0,0,0-.023.816.571.571,0,0,0,.816.023l1.22-1.22v-1.426a3.008,3.008,0,0,0-.709.5Z",
  transform: "translate(-1412.5 258.033)",
  fill: "#5351fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_545",
  "data-name": "Group 545",
  transform: "translate(6.51 9.388)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M1424.61-244.41l-.031.031-2.418,2.425a.436.436,0,0,0-.053.069.57.57,0,0,0,.046.747.594.594,0,0,0,.824,0l2.456-2.456a.578.578,0,0,0-.031-.816A.571.571,0,0,0,1424.61-244.41Z",
  transform: "translate(-1418.887 247.75)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M1423.263-240.633l-1.181,1.181a1.8,1.8,0,0,1-2.459.133,1.746,1.746,0,0,1-.539-.917,1.716,1.716,0,0,1,.412-1.525.484.484,0,0,1,.061-.069l1.228-1.228a.58.58,0,0,0,0-.824.585.585,0,0,0-.816,0l-1.228,1.228a2.946,2.946,0,0,0-.595.892,3,3,0,0,0-.2,1.525,2.862,2.862,0,0,0,.846,1.678,2.9,2.9,0,0,0,4.034,0l1.228-1.228a.628.628,0,0,0,.183-.45.609.609,0,0,0-.16-.374A.585.585,0,0,0,1423.263-240.633Z",
  transform: "translate(-1417.921 247.626)",
  fill: "#5351fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M1428.081-247.855a2.339,2.339,0,0,0-.328-.29,2.894,2.894,0,0,0-3.051-.29,3.009,3.009,0,0,0-.709.5l-.076.076-1.228,1.228a.578.578,0,0,0-.023.816.571.571,0,0,0,.816.023l1.182-1.183a1.8,1.8,0,0,1,2.392-.188,1.737,1.737,0,0,1,.132,2.575l-1.228,1.228a.578.578,0,0,0-.023.816.571.571,0,0,0,.816.023l.023-.023.976-.976.252-.252A2.884,2.884,0,0,0,1428.081-247.855Z",
  transform: "translate(-1419.01 248.74)",
  fill: "#5351fb"
}))));

var SvgApplicationLinks = function SvgApplicationLinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicationLinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/application-links.4fb18321.svg";
export { ForwardRef as ReactComponent };